import React from 'react'

function ContactForm() {
    return (
        <div className='bg-white p-12 shadow rounded-lg'>
            <h1 className="text-primary-base font-bold text-3xl">Message Us</h1>
            <p className='text-gray-600 mt-1'>Send us your message and we will contact you soon!</p>
            <form action="" className='flex flex-col space-y-4 w-full mt-8'>
                <input type="text" name="" id="" className='focus:border-primary-base focus:ring-primary-base rounded-sm' placeholder='Full Name' />
                <input type="text" name="" id="" className='focus:border-primary-base focus:ring-primary-base rounded-sm' placeholder='Email Address' />
                <textarea name="" id="" cols={1} rows={6} className='focus:border-primary-base focus:ring-primary-base rounded-sm' placeholder='Write your message here......'></textarea>
                <input type="submit" value="Send Message" className='bg-primary-base px-3 py-2 text-white rounded-md w-fit cursor-pointer transition-all duration-300 hover:bg-primary-dark-700 hover:transition' />
            </form>
        </div>
    )
}

export default ContactForm